import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

const DashFooter = ({ isOpen }) => {
  return (
    <DashMain>
      <p>System Status: All Good</p>
      <ul>
        <li>@2023 Money Manager, Inc.</li>
        <li>
          <Link to="#">Status</Link>
        </li>
        <li>
          <Link to="#">Terms</Link>
        </li>
        <li>
          <Link to="#">Privacy</Link>
        </li>
        <li>
          <Link to="#">Contact Sales</Link>
        </li>
      </ul>
    </DashMain>
  );
};

export default DashFooter;

const DashMain = styled.div`
  padding: 10px 0px;
  position: static;
  bottom: 0%;
  margin-top: 3rem;
  border-top: 1px solid #cfcfcf;
  width: 85%;

  p {
    font-size: 15px;
    font-weight: 400;
    color: #333333;
  }
  ul {
    display: flex;
    margin-top: 5px;
    li {
      list-style: none;
      margin-right: 20px;
      font-size: 15px;
      color: #333333;
      a {
        color: #333333;
        &:hover {
          color: blue;
        }
      }
    }
    @media only screen and (max-width: 991px) {
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: column;

      li {
        margin-bottom: 15px;
        font-size: 16px;
      }
    }
  }

  @media only screen and (max-width: 991px) {
    width: 100%;
  }
`;
